import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './resources/en.json';
import es from './resources/es.json';

export const langs = [
    {
        value: 'es',
        label: 'Español',
        icon: "https://flagcdn.com/40x30/es.png",
    },
    {
        value: 'en',
        label: 'English',
        icon: "https://flagcdn.com/40x30/us.png",
    },
];

const resources = {
    en: { translation: en },
    es: { translation: es }
};

const storedLang = window.localStorage.getItem('lang') || 'es';

i18n.use(initReactI18next).init({
    resources,
    lng: storedLang,
    fallbackLng: 'es',
    interpolation: {
        escapeValue: false,
    },
})

export default i18n;